import { graphql, useStaticQuery } from 'gatsby'

const queryEN = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/content/en/tutorials/" } }, limit: 6) {
      edges {
        node {
          frontmatter {
            title
            description
            api
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

const useUseCaseEN = () => {
  const { allMarkdownRemark } = useStaticQuery(queryEN)
  const { edges: data } = allMarkdownRemark

  return data
}

export default useUseCaseEN
